import { Breakpoint } from '@material-ui/core/styles/createBreakpoints';

export const UIBreakPoint = 'md' as Breakpoint;
export const DeviceSensitive = true;
